import {lazy} from "react";
import {IComponentTypeMapping} from "./ComponentType";

// eslint-disable-next-line import/prefer-default-export
export const ComponentTypeMappings: IComponentTypeMapping = {
    // ========= Dashboard Components ==============
    SparkLineValueIndicator: {
        name: "Spark Line Value Indicator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/sparkline/SparkLine" /* webpackChunkName: "spark-line" */),
        editorEntryPoint: lazy(() => import("./dashboard/sparkline/SparkLineEditor") /* webpackChunkName: "spark-line-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/spark-line-value-indicator/spark-line-value-indicator.png"
    },
    SparkLineAdvanced: {
        name: "Spark Line Advanced",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/sparkline-advanced/SparkLineAdvanced" /* webpackChunkName: "spark-line-advanced" */),
        editorEntryPoint: lazy(() => import("./dashboard/sparkline-advanced/SparkLineAdvancedEditor") /* webpackChunkName: "spark-line-advanced-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/spark-line-advanced/spark-line-advanced.png"
    },
    DatasetCollapseDataTable: {
        name: "Dataset Collapse Data Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-collapse-data-table/DatasetCollapseDataTable" /* webpackChunkName: "dataset-collapse-data-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-collapse-data-table/dataset-collapse-data-table-editor/DatasetCollapseDataTableEditor") /* webpackChunkName: "dataset-collapse-data-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/dataset-collapse-data-table/dataset-collapse-data-table.png"
    },
    MeasurementDeviceTableAgreg: {
        name: "Measurement Device Table Aggregated",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/measurement-device-table-agreg/MeasurementDeviceTableAgreg" /* webpackChunkName: "measurement-device-table-agreg" */),
    },
    DatasetIndicator: {
        name: "Dataset Gauge Indicator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-indicator/DatasetIndicator" /* webpackChunkName: "dataset-indicator" */),
    },
    ProductTemplateTable: {
        name: "Product Template Table",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/product-template-table/ProductTemplateTable" /* webpackChunkName: "product-template-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/product-template-table/product-template-table-editor/ProductTemplateTableEditor") /* webpackChunkName: "product-template-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-management-components/product-template-table/product-template-table.png"
    },
    DatasetLineChart: {
        name: "Dataset Line Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/dataset-line-chart/DatasetLineChart" /* webpackChunkName: "dataset-line-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-line-chart/DatasetLineChartEditor") /* webpackChunkName: "dataset-line-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/line-chart/line-chart.png"
    },
    DatasetHistogramChart: {
        name: "Dataset Histogram Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/histogram/HistogramChart" /* webpackChunkName: "dataset-histogram-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/histogram/histogram-editor/HistogramChartEditor") /* webpackChunkName: "dataset-histogram-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/histogram/histogram.png"
    },
    DatasetBarChart: {
        name: "Dataset Bar Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/bar-chart/DatasetBarChartRenderer" /* webpackChunkName: "dataset-bar-chart-renderer" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/bar-chart/bar-editor/DatasetBarChartEditor") /* webpackChunkName: "dataset-bar-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/bar-chart/bar-chart.png"
    },
    GridHeatMap: {
        name: "Dataset Grid Heatmap",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/grid-heatmap/GridHeatmap" /* webpackChunkName: "grid-heatmap" */),
        editorEntryPoint: lazy(() => import("./dashboard/grid-heatmap/grid-heatmap-editor/GridHeatmapEditor") /* webpackChunkName: "grid-heatmap-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/dataset-gird-heatmap/dataset-grid-heatmap.png"
      },
    DatasetScatterChart: {
        name: "Dataset Scatter Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/dataset-scatter-chart/DatasetScatterChart" /* webpackChunkName: "dataset-scatter-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-scatter-chart/DatasetScatterChartEditor") /* webpackChunkName: "dataset-scatter-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/scatter-chart/scatter-1.png"
    },
    DatasetPieChart: {
        name: "Dataset Pie Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/DatasetPieChart" /* webpackChunkName: "dataset-pie-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-pie-chart/DatasetPieChartEditor") /* webpackChunkName: "dataset-pie-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/pie-chart/pie-chart.png"
    },
    DatasetSankeyChart: {
        name: "Dataset Sankey Chart",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/charts/sankey-chart/Sankey" /* webpackChunkName: "dataset-sankey-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/sankey-chart/sankey-editor/SankeyEditor") /* webpackChunkName: "dataset-sankey-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/sankey-diagram/sankey-diagram.png"
    },
    DataInputOutputTable: {
        name: "Data Input Output Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/data-input-output-table/main-table/DataInputOutputTable" /* webpackChunkName: "data-input-output-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/data-input-output-table/data-input-output-table-editor/DataInputOutputTableEditor") /* webpackChunkName: "data-input-output-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-management-components/data-input-output-table/data-input-output-table.png"
    },
    Scada: {
        name: "SCADA",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/scada/Scada" /* webpackChunkName: "scada" */),
        editorEntryPoint: lazy(() => import("./dashboard/scada/scada-editor/ScadaEditor") /* webpackChunkName: "scada-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/advanced-monitoring--control-components/scada/dryer.png"
    },
    DatasetToggleTable: {
        name: "Dataset Toggle Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-toggle-table/DatasetToggleTable" /* webpackChunkName: "dataset-toggle-table" */),
    },
    DatasetSetpointTable: {
        name: "Dataset Setpoint Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-setpoint-table/DatasetSetpointTable" /* webpackChunkName: "dataset-setpoint-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-setpoint-table/dataset-setpoint-table-editor/DatasetSetpointTableEditor") /* webpackChunkName: "dataset-setpoint-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-management-components/setpoint-table/setpoint-table-2.png"
    },
    CalendarHeatmap: {
        name: "Calendar Heatmap",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/calendar-heatmap/CalendarHeatmap" /* webpackChunkName: "calendar-heatmap" */),
        editorEntryPoint: lazy(() => import("./dashboard/calendar-heatmap/calendar-heatmap-editor/CalendarHeatmapEditor") /* webpackChunkName:        "calendar-heatmap-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/advanced-monitoring--control-components/calendar-heatmap/availability_1.png"
    },
    DatasetTable: {
        name: "Dataset Table",
        dashboardComponent: true,
        supportsStatusCallback: true,
        entryPoint: () => import("./dashboard/dataset-table/DatasetTable" /* webpackChunkName: "dataset-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-table/dataset-table-editor/DatasetTableEditor") /* webpackChunkName: "dataset-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-management-components/dataset-table/dataset-table.png"
    },
    ConfidenceIntervalLineChart: {
        name: "Confidence Interval Line Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/confidence-interval-line-chart/ConfidenceIntervalLineChart" /* webpackChunkName: "confidence-interval-line-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/confidence-interval-line-chart/ConfidenceIntervalLineChartEditor") /* webpackChunkName: "confidence-interval-line-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/confidence-interval-line-chart/confidence-line-chart-min-max.png"
    },
    DatasetDataInputTable: {
        name: "Dataset Data Input Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-data-input-table/DatasetDataInputTable" /* webpackChunkName: "dataset-data-input-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-data-input-table/dataset-data-input-table-editor/DatasetDataInputTableEditor") /* webpackChunkName: "dataset-data-input-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-management-components/dataset-data-input-table/dataset-data-input-table.png"
    },
    UniversalDatasetTable: {
        name: "Universal Dataset Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/universal-dataset-table/UniversalDatasetTable" /* webpackChunkName: "dataset-data-input-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/universal-dataset-table/universal-dataset-table-editor/UniversalDatasetTableEditor") /* webpackChunkName: "dataset-data-input-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/universal-dataset-table/universal-dataset-table.png"
    },
    EapsmLicenceManager: {
        name: "Eapsm License Manager",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/eapsm-license-manager/EapsmLicenseManager" /* webpackChunkName: "eapsm-license-manager" */),
    },
    FreeText: {
        name: "Free Text",
        dashboardComponent: true,
        entryPoint: () => import("./pages/dashboard/components/free-text/FreeText" /* webpackChunkName: "free-text" */),
        editorEntryPoint: lazy(() => import("./pages/dashboard/components/free-text/FreeTextEditor") /* webpackChunkName: "free-text-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/utility-components/free-text/free-text.png"
    },
    GranttChart: {
        name: "Gantt Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/gantt-chart/Gantt" /* webpackChunkName: "gantt-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/gantt-chart/GanttChartEditor") /* webpackChunkName: "gantt-chart-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/gantt-chart/gantt-chart.png"
    },
    GeneratedReportTable: {
        name: "Generated Report Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/generated-report-table/GeneratedReportTable" /* webpackChunkName: "generated-report-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/generated-report-table/generated-report-table-editor/GeneratedReportTableEditor") /* webpackChunkName: "generated-report-table-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/generated-report-table/generated-report-table.png"
    },
    AlertFan: {
        name: "Alert Fan",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/alert-fan/AlertTabMain" /* webpackChunkName: "alert-fan-tab" */),
        editorEntryPoint: lazy(() => import("./dashboard/alert-fan/AlertFanEditor" /* webpackChunkName: "alert-fan-editor" */)),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-management-components/alerts-table/alerts-table.png"
    },
    PIDController: {
        name: "PID Controller",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/pid-controller/PIDController" /* webpackChunkName: "pid-controller" */),
        editorEntryPoint: lazy(() => import("./dashboard/pid-controller/PIDControllerEditor") /* webpackChunkName: "pid-controller-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/advanced-monitoring--control-components/pid-controller/pid-controller.png"
    },
    DashboardRedirectButton: {
        name: "Dashboard Redirect Button",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/redirect-button/DashboardRedirectButton" /* webpackChunkName: "dashboard-redirect-button" */),
        editorEntryPoint: lazy(() => import("./dashboard/redirect-button/DashboardRedirectButtonEditor") /* webpackChunkName: "dashboard-redirect-button-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/utility-components/button-component/button-component.png"
    },
    Separator: {
        name: "Separator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/separator/Separator" /* webpackChunkName: "separator" */),
        editorEntryPoint: lazy(() => import("./dashboard/separator/SeparatorEditor") /* webpackChunkName: "separator-editor" */),
        imageUrl: "https://docs.dween.com/components/dashboard-components/utility-components/separator/separator.png"
    },
    InstantJobEnqueueConfigurator: {
        name: "Instant Job Enqueue Configurator",
        dashboardComponent: true,
        entryPoint: () => import("./company-specific/viking-malt/best-batch-calculator/VikingMaltBestBatchCalculator" /* webpackChunkName: "instant-job-enqueue-configurator" */),
    },
    DevicesMap: {
        name: "Devices Map",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/devices-map/DevicesMap" /* webpackChunkName: "devices-map" */),
    },
    LastKnownValueTimeMoment: {
        name: "Last Known Value Time Moment",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/last-known-value-time-moment/LastKnownValueTimeMoment" /* webpackChunkName: "last-known-value-time-moment" */),
        editorEntryPoint: lazy(() => import("components/dashboard/last-known-value-time-moment/LastKnownValueTimeMomentEditor" /* webpackChunkName: "last-known-value-time-moment-editor" */)),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/last-known-value-time-moment/last-known-value-time-moment.png"
    },
    WeatherMonitoring: {
        name: "Weather Monitoring",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/weather-monitoring/WeatherMonitoring" /* webpackChunkName: "weather-monitoring" */),
        editorEntryPoint: lazy(() => import("components/dashboard/weather-monitoring/WeatherMonitoringEditor" /* webpackChunkName: "weather-monitoring-editor" */)),
        imageUrl: "https://docs.dween.com/components/dashboard-components/advanced-monitoring--control-components/weather-monitoring/weather-monitoring-daily.png"
    },
    DatasetStatusMonitoring: {
        name: "Dataset Status Monitoring",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/dataset-status-monitoring/DatasetStatusMonitoring" /* webpackChunkName: "dataset-status-monitoring" */),
        editorEntryPoint: lazy(() => import("components/dashboard/dataset-status-monitoring/DatasetStatusMonitoringEditor" /* webpackChunkName: "dataset-status-monitoring-editor" */)),
        imageUrl: "https://docs.dween.com/components/dashboard-components/advanced-monitoring--control-components/dataset-status-monitoring/dataset-status-monitoring.png"
    },
    ProductTemplateBubbleChart: {
        name: "Product Template Bubble Chart",
        dashboardComponent: true,
        entryPoint: () => import("components/dashboard/product-template-bubble-chart/ProductTemplateBubbleChart" /* webpackChunkName: "product-template-bubble-chart" */),
        editorEntryPoint: lazy(() => import("components/dashboard/product-template-bubble-chart/product-template-bubble-chart-editor/ProductTemplateBubbleChartEditor" /* webpackChunkName: "product-template-bubble-chart-editor" */)),
        imageUrl: "https://docs.dween.com/components/dashboard-components/data-visualization-components/product-template-bubble-chart/product-template-bubble-chart.png"
    },

    // ==================== Page Fragments ====================
    DashboardComponentConfigurator: {
        name: "Dashboard Component Configurator",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/DashboardComponentConfigurator" /* webpackChunkName: "dashboard-component-configurator" */)
    },
    DashboardFragment: {
        name: "Dashboard fragment",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/dashboard/DashboardFragment" /* webpackChunkName: "dashboard-fragment" */)
    },
    ProductTemplateConfiguratorJson: {
        name: "Product Template Configurator (JSON)",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/product-template-configurator/ProductTemplatesConfiguratorJson" /* webpackChunkName: "prod-templates-configurator" */)
    },
    DataWindowChart: {
        name: "Data Window Chart",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/DataWindowChart" /* webpackChunkName: "data-window-chart" */)
    },
    ProductTemplateDataManagerFragment: {
        name: "Product Template Data Manager",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/ProductTemplateDataManagerFragment" /* webpackChunkName: "product-template-data-manager" */)
    },
    CompanyContextSelect: {
        name: "Company Context Select",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/company-context-select/CompanyContextSelect" /* webpackChunkName: "company-context-select" */)
    },

    EasasGlobalFragment: {
        name: "Global Fragment",
        invisible: true,
        entryPoint: () => import("./fragments/easas-global-fragment/EasasGlobalFragment" /* webpackChunkName: "product-template-data-manager" */),
    },

  // ==================== Pages ====================
  EasasMain: {
    name: "Easas Main",
    dashboardComponent: false,
    entryPoint: () => import("./pages/easas-main/EasasMain" /* webpackChunkName: "easas-main" */),
  } ,
  ScheduleBookingPage: {
    name: "ScheduleBookingPage",
    dashboardComponent: false,
    entryPoint: () =>
      import("./pages/schedule-booking/ScheduleBooking" /* webpackChunkName: "schedule-booking" */),
  },
  ScheduledAirflowTaskConfigPage: {
    name: "Scheduled Task Config",
    dashboardComponent: false,
    entryPoint: () =>
      import(
        "./pages/scheduled-task-airflow/AirflowTaskConfigurator" /* webpackChunkName: "scheduled-airflow-task-config-page" */
      ),
  },
  DatasetPage: {
    name: "Datasets",
    dashboardComponent: true,
    entryPoint: () => import("./dashboard/dataset-window" /* webpackChunkName: "dataset-window" */),
  },
  DashboardReportsPage: {
    name: "DashboardReportsPage",
    dashboardComponent: false,
    entryPoint: () =>
      import(
        "./pages/dashboard-report/DashboardReportPage" /* webpackChunkName: "dashboard-reports-page" */
      ),
  },
  UserSessionStatsPage: {
    name: "User Session Stats Page",
    dashboardComponent: false,
    entryPoint: () =>
      import(
        "./pages/users-statistics-dashboard/UsersStatisticsDashboard" /* webpackChunkName: "dashboard-reports-page" */
      ),
  },
  CompanyFilesPage: {
    name: "Company Files Page",
    entryPoint: () =>
      import("./pages/company-files/CompanyFilesPage" /* webpackChunkName: "company-files-page" */),
  },
  MeasurementDeviceManagementPage: {
    name: "Measurement Devices",
    entryPoint: () =>
      import(
        "components/pages/measurement-devices/MeasurementDevicesRoot" /* webpackChunkName: "measurement-devices-management" */
      ),
  },

  // ========= Dev ==============
  ReactExample: {
    name: "DEV TEST",
    dashboardComponent: true,
    entryPoint: () => import("./dashboard/test/App" /* webpackChunkName: "react-example" */),
  },
  FailingComponentTest: {
    name: "Fail Test component",
    dashboardComponent: true,
    supportsStatusCallback: true,
    entryPoint: () =>
      import(
        "components/dashboard/failing-component-test/FailingComponentTest" /* webpackChunkName: "failing-component-test" */
      ),
  },
  DevSandbox: {
    name: "Dev Sandbox",
    dashboardComponent: true,
    entryPoint: () => import("./dashboard/dev-sandbox/DevSandbox" /* webpackChunkName: "dev-sandbox" */),
  },
};


export const dashboardComponentOptions = Object.keys(ComponentTypeMappings)
.filter(key => ComponentTypeMappings[key].dashboardComponent)
.map(key => ({
  name: ComponentTypeMappings[key].name,
  id: key,
  tooltipImage: ComponentTypeMappings[key].imageUrl
}));